import React from "react";
import { Modal } from "reactstrap";
import { useLocationSession } from "components/location/LocationSessionProvider";
import { Button } from "components/ui/button";

const LocationSyncModal = () => {
  const { acceptSyncLocation, isSwitching, syncLocation } = useLocationSession();

  return (
    <Modal
      isOpen={Boolean(syncLocation)}
      toggle={() => null}
      size="md"
      centered
      backdrop="static"
      keyboard={false}
      backdropClassName="backdrop-style"
    >
      <div className="tw-p-5 tw-text-center">
        <h3 className="fs-24 fw-900 mb-2">Location Update</h3>
        <p className="fs-16 fw-450 text-muted mb-4">
          Current Location switched to {syncLocation?.name} on another device.
        </p>
        <Button variant="primary" loading={isSwitching} onClick={acceptSyncLocation}>
          Switch Location
        </Button>
      </div>
    </Modal>
  );
};

export default LocationSyncModal;
